import { FetchNotificationsOnPageChangeGlobalHandler } from './FetchNotificationsOnPageChangeGlobalHandler';
import { OverrideABExperimentsWithUrlParamsGlobalHandler } from './OverrideABExperimentsWithUrlParamsGlobalHandler';
import { PageVisitCounterGlobalHandler } from './PageVisitCounterGlobalHandler';
import { QueuedTrackersGlobalHandler } from './QueuedTrackersGlobalHandler';
import { ScrolledDirectionGlobalHandler } from './ScrolledDirectionGlobalHandler';
import { SetClientHydratedGlobalHandler } from './SetClientHydratedGlobalHandler';
import { SetFlashesGlobalHandler } from './SetFlashesGlobalHandler';
import { SetGMapsErrorGlobalHandler } from './SetGMapsErrorGlobalHandler';
import { ShowUserModalsGlobalHandler } from './ShowUserModalsGlobalHandler';
import { TrackNavigationStateGlobalHandler } from './TrackNavigationStateGlobalHandler';
import { UpdateSearchLocationFromLocalStorageGlobalHandler } from './UpdateSearchLocationFromLocalStorageGlobalHandler';
import { VMOnboardingModalsExperimentGlobalHandler } from './VMOnboardingModalsExperimentGlobalHandler';

/*
 * Wrap app hooks to prevent them from re-rendering the whole tree
 */
export function GlobalHandlers() {
  return (
    <>
      <QueuedTrackersGlobalHandler />
      <TrackNavigationStateGlobalHandler />
      <VMOnboardingModalsExperimentGlobalHandler />
      <ShowUserModalsGlobalHandler />
      <FetchNotificationsOnPageChangeGlobalHandler />
      <ScrolledDirectionGlobalHandler />
      <PageVisitCounterGlobalHandler />
      <SetClientHydratedGlobalHandler />
      <UpdateSearchLocationFromLocalStorageGlobalHandler />
      <OverrideABExperimentsWithUrlParamsGlobalHandler />
      <SetFlashesGlobalHandler />
      <SetGMapsErrorGlobalHandler />
    </>
  );
}
